import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUmbrella = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 676,
	height: 461,
	fill: "none",
	viewBox: "0 0 676 461",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 260.5,
			cy: 57.1,
			fill: "#F5D493",
			rx: 260.5,
			ry: 57.1,
			transform: "matrix(-1 0 0 1 521 346.1)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 106.1,
			cy: 23.3,
			fill: "#F5D493",
			rx: 106.1,
			ry: 23.3,
			transform: "matrix(-1 0 0 1 276.3 288.6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M240.4 236.9h4.9l-7.6 72.4h-5l7.7-72.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m239 234.2 1.5 2.7-7.8 72.4-2-1.5 8.3-73.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m215.1 182.2 2.5-3.4 58.6 140-2.7 2.8L215 182.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M217.6 178.8h6.3l58.7 140h-6.4l-58.6-140Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m276.2 318.7-2.9 3h7.5l1.7-3h-6.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M217.4 182.6h-76.3s4.5 40.6 14.3 64.4a299 299 0 0 0 22.3 39.8H249s-15.6-32.6-22-54.8c-5.5-18.9-9.7-49.4-9.7-49.4Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_16263_2353",
			width: 109,
			height: 103,
			x: 141,
			y: 182,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "M217.4 182.6h-76.3s4.5 40.6 14.3 64.4a419.5 419.5 0 0 0 19 37.8H249s-15.6-30.6-22-52.8c-5.5-18.9-9.7-49.4-9.7-49.4Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#FB8431",
			mask: "url(#mask0_16263_2353)",
			children: /* @__PURE__ */ _jsx("path", { d: "M215.6 182.6h-7.9s5.8 40 13.3 64.7c5.2 17 21 39.5 21 39.5h4.2s-12-24-18.1-43.1c-7-21.8-12.5-61-12.5-61Zm-16.5 0h-7.8s5.8 40 13.3 64.7c5.2 17 21 39.5 21 39.5h4.2s-12-24-18.2-43.1c-7-21.8-12.5-61-12.5-61Zm-15.5 0h-7.8s5.8 40 13.3 64.7c5.2 17 21 39.5 21 39.5h4.2s-12-24-18.2-43.1c-7-21.8-12.5-61-12.5-61Zm-16.9 0h-7.9s5.8 40 13.3 64.7c5.2 17 21 39.5 21 39.5h4.2s-12-24-18.2-43.1c-7-21.8-12.4-61-12.4-61Zm-16 0h-7.9s8 45.8 15.5 70.5c5.2 17 18.8 33.7 18.8 33.7h4.2s-12-24-18.1-43.1c-7-21.8-12.5-61-12.5-61Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m277.2 263.5 4.9 1.6-37.6 43.2H238l39.2-44.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m276.2 258.4 1 5.1-39 44.8.3-6.5 37.7-43.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m277.2 263.5-1-5 4.6 1.1 1.3 5.4-4.9-1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M262 286.5h-75s5.1-5 6.8-9c1.6-3.5 2.2-9.6 2.2-9.6h75.8s-.2 6.9-2.2 10.6c-2 3.9-7.7 8-7.7 8Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_16263_2353",
			width: 85,
			height: 20,
			x: 187,
			y: 267,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "M262 286.5h-75s5.1-5 6.8-9c1.6-3.5 2.2-9.6 2.2-9.6h75.8s-.2 6.9-2.2 10.6c-2 3.9-7.7 8-7.7 8Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#FB8431",
			mask: "url(#mask1_16263_2353)",
			children: /* @__PURE__ */ _jsx("path", { d: "m224 286.8-7.8-.3s8.4-2.9 11.4-8c2-3.4 2.9-10.6 2.9-10.6h8.2s-1 7.3-2.7 10.6c-2.8 5.5-12 8.3-12 8.3Zm-16.6 0-8.4-.3s8.4-2.9 11.4-8c2-3.4 2.4-10.6 2.4-10.6h8.7s-1 7.3-2.6 10.6c-2.9 5.5-11.5 8.3-11.5 8.3Zm-13.1 0-6.4-.3s4.5-2.9 7.5-8c2-3.4 2.4-10.6 2.4-10.6h6.8s-1 7.3-2.7 10.6a22 22 0 0 1-7.6 8.3Zm47 0-8-.3s9-2.9 12-8c2-3.4 2.6-10.6 2.6-10.6h8s-1 7.3-2.7 10.6c-2.8 5.5-12 8.3-12 8.3Zm15.5 0-8-.3s9.5-2.9 12.4-8c2-3.4 3-10.6 3-10.6h7.2s-1 7.3-2.7 10.6c-2.8 5.5-12 8.3-12 8.3Z" })
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 79.9,
			height: 6.3,
			x: 195.1,
			y: 261.6,
			fill: "#fff",
			rx: 3.1
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FB8431",
			d: "M263 261.6h6.5a3.1 3.1 0 0 1 0 6.3h-6.6l.5-.4a3.7 3.7 0 0 0-.5-6Zm-16 0h6.5a3.1 3.1 0 1 1 0 6.3h-6.6l.5-.4a3.7 3.7 0 0 0-.5-6Zm-16.5 0h6.5a3.1 3.1 0 1 1 0 6.3h-6.5l.4-.4a3.7 3.7 0 0 0-.4-6Zm-16.5 0h6.6a3.1 3.1 0 1 1 0 6.3H214l.4-.4a3.7 3.7 0 0 0-.4-6Zm-16.5 0h6.6a3.1 3.1 0 0 1 0 6.3h-6.6l.5-.4a3.7 3.7 0 0 0-.5-6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M155.2 236.9h4.8l-7.5 72.4h-5l7.7-72.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m153.7 234.2 1.6 2.7-7.9 72.4-2-1.5 8.3-73.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m192.5 264.5 4.9 1.6-37.6 43.2h-6.6l39.3-44.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m191.5 259.4 1 5-39 44.9.2-6.6 37.8-43.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m192.5 264.5-1-5.1 4.6 1.2 1.2 5.3-4.8-1.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m131.3 182.2 2.6-3.4 58.6 140-2.8 2.8-58.4-139.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M133.9 178.8h6.2l58.7 140h-6.4l-58.5-140Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m192.5 318.7-3 3h7.6l1.7-3h-6.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M483.7.8 373.3 121.6s25.3 28.7 47 37.8c21.2 8.9 58.6 7.2 58.6 7.2L483.7.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m484 .4-205.4 77s17.3 26.9 38.5 35.8c21.2 9 56.2 8.4 56.2 8.4L484 .4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m483.7 0 93.5 206s-25.3 2-55.4-6.5c-30-8.4-43-32.5-43-32.5l4.9-167Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "m484 .4-297 33s16.9 27.6 39.3 38.9c22.5 11.2 55.5 4.2 55.5 4.2L484 .4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "m483.7.4 168.2 234.4s-16.4 4.4-39.8-4.8c-23.4-9.1-34.5-23.7-34.5-23.7L483.6.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D66313",
			d: "M350.4 247.7c-21.5 56-45 147-45 147h20.9s18-83 36.1-134.2A1419.2 1419.2 0 0 1 409 152.1l-12.8-7.6s-30 62-45.8 103.2Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 212.5,
			cy: 391.9,
			fill: "#F5D493",
			rx: 37.5,
			ry: 2.4
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 223.4,
			cy: 350.8,
			fill: "#fff",
			rx: 41.1,
			ry: 38.8
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_16263_2353",
			width: 83,
			height: 78,
			x: 182,
			y: 312,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 223.4,
				cy: 350.8,
				fill: "#D9D9D9",
				rx: 41.1,
				ry: 38.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_16263_2353)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#F76E6E",
					d: "M255.9 326c-6.7-3.8-22.8-.8-22.8-.8s20.7 12.3 26.6 26.7c3.4 8.2 2.6 18.2 2.6 18.2s14-32.2-6.4-44Zm-24.4-13.3c3.8 2.6 4.5 11.7 4.5 11.7s-12.8-6.9-23.7-6.7c-6.1 0-13.6 1.2-13.6 1.2s21.3-14.2 32.8-6.2Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#F76E6E",
					d: "M230.1 361.9c-2.8 11.2-12.7 30-12.7 30l-24.3-9.3-9.4-18.2s7.7-14 14.9-21c11.1-11 35.2-19.1 35.2-19.1s-.1 23.3-3.7 37.6Z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 234.3,
					cy: 325.6,
					r: 6.9,
					fill: "#E33C78"
				})
			]
		})
	]
});
export default SvgUmbrella;
